"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRegionAttr = isRegionAttr;
function isRegionAttr(attr) {
    return attr?.value.valueType === 'region';
}
//# sourceMappingURL=region.guard.js.map